export default __webpack_public_path__ + "static/media/higher_url_mark.d338d645.svg";